import { jsxAsElement as jsx } from 'web-shared/src/lib/jsx';
import { TypedAttributes, TypedElement } from '../htmlElementTyped';
import { addHoverEffect } from '../old/utils';

export interface AlbumAttributes extends TypedAttributes {
  name: string;
  artist?: string;
  artwork?: string;
  link?: string;
}

export class Album extends TypedElement<AlbumAttributes> {
  constructor() {
    super();
  }

  render = async () => {
    const { name, artist, artwork, link } = this.typedAttributes;

    this.innerHTML = '';

    const image = <img src={artwork || '/placeholder.svg'} alt={name} />;
    addHoverEffect(image);

    this.append(
      <div class="album">
        {image}
        <div className="main">{name}</div>
        <p className="sub">{artist}</p>
        {link ? (
          <a href={link} class="link">
            Listen Online
          </a>
        ) : (
          ''
        )}
      </div>,
    );
  };

  connectedCallback() {
    void this.render();
  }
}
